module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec05_sp_689822e8201d482979c0d76614ccc4fe.jpg";